import { render, staticRenderFns } from "./ExamQuestion.vue?vue&type=template&id=332907e0"
import script from "./ExamQuestion.vue?vue&type=script&lang=js"
export * from "./ExamQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports